import { ConfigProvider } from './config-provider';
export { useConfig, setDefaultConfig, getDefaultConfig } from './config-provider';
export default ConfigProvider;